import {
    Contract,
    FetchContractRequestAction,
    FetchContractSuccessAction,
    FetchContractFailureAction,
    ContractId,
    PostContractRequestAction,
    PostContractSuccessAction,
    PostContractFailureAction,
    FetchLegalInformationRequestAction,
    FetchLegalInformationSuccessAction,
    FetchLegalInformationFailureAction,
    TravelInformation,
    Traveler,
    ContractEditStep,
    SetContractEditStepAction,
    SerializedLegalInformation,
    QuotePricing,
    FetchQuotePricingFailureAction,
    FetchQuotePricingRequestAction,
    FetchQuotePricingSuccessAction,
    PostProofOfDocumentsRequestAction,
    PostProofOfDocumentsSuccessAction,
    PostProofOfDocumentsFailureAction,
    ProofDocument,
    DeleteProofOfDocumentsRequestAction,
    DeleteProofOfDocumentsSuccessAction,
    DeleteProofOfDocumentsFailureAction,
    PostChangeQuotePricesRequestAction,
    PostChangeQuotePricesSuccessAction,
    PostChangeQuotePricesFailureAction,
    FilledQuotePricing,
    PreviousContractEditStepAction,
    PostPaymentScheduleRequestAction,
    PostPaymentScheduleSuccessAction,
    PostPaymentScheduleFailureAction,
    PaymentScheduleViewModel,
    ChangeCurrencyPaymentScheduleAction,
    PutPaymentScheduleRequestAction,
    PutPaymentScheduleSuccessAction,
    PutPaymentScheduleFailureAction,
    PostInstalmentRequestAction,
    PostInstalmentSuccessAction,
    PostInstalmentFailureAction,
    InstalmentViewModel,
    ExistingPaymentSchedule,
    PutInstalmentRequestAction,
    PutInstalmentSuccessAction,
    PutInstalmentFailureAction,
    DeleteInstalmentRequestAction,
    DeleteInstalmentFailureAction,
    DeleteInstalmentSuccessAction,
} from './types';

export const setContractEditStepAction = 'contract/SET_CONTRACT_EDIT_STEP' as const;
export const goToPreviousContractEditStepAction =
    'contract/GO_TO_PREVIOUS_CONTRACT_EDIT_STEP' as const;
export const fetchContractRequestAction = 'contract/FETCH_CONTRACT_REQUEST' as const;
export const fetchContractSuccessAction = 'contract/FETCH_CONTRACT_SUCCESS' as const;
export const fetchContractFailureAction = 'contract/FETCH_CONTRACT_FAILURE' as const;
export const postContractRequestAction = 'contract/POST_CONTRACT_REQUEST' as const;
export const postContractSuccessAction = 'contract/POST_CONTRACT_SUCCESS' as const;
export const postContractFailureAction = 'contract/POST_CONTRACT_FAILURE' as const;
export const fetchLegalInformationRequestAction =
    'contract/FETCH_LEGAL_INFORMATION_REQUEST' as const;
export const fetchLegalInformationSuccessAction =
    'contract/FETCH_LEGAL_INFORMATION_SUCCESS' as const;
export const fetchLegalInformationFailureAction =
    'contract/FETCH_LEGAL_INFORMATION_FAILURE' as const;
export const fetchQuotePricingRequestAction = 'contract/FETCH_QUOTE_PRICING_REQUEST' as const;
export const fetchQuotePricingSuccessAction = 'contract/FETCH_QUOTE_PRICING_SUCCESS' as const;
export const fetchQuotePricingFailureAction = 'contract/FETCH_QUOTE_PRICING_FAILURE' as const;
export const postProofOfDocumentsRequestAction =
    'contract/POST_PROOF_OF_DOCUMENTS_REQUEST' as const;
export const postProofOfDocumentsSuccessAction =
    'contract/POST_PROOF_OF_DOCUMENTS_SUCCESS' as const;
export const postProofOfDocumentsFailureAction =
    'contract/POST_PROOF_OF_DOCUMENTS_FAILURE' as const;
export const deleteProofOfDocumentRequestAction =
    'contract/DELETE_PROOF_OF_DOCUMENTS_REQUEST' as const;
export const deleteProofOfDocumentsSuccessAction =
    'contract/DELETE_PROOF_OF_DOCUMENTS_SUCCESS' as const;
export const deleteProofOfDocumentsFailureAction =
    'contract/DELETE_PROOF_OF_DOCUMENTS_FAILURE' as const;
export const postChangeQuotePricesRequestAction =
    'contract/POST_CHANGE_QUOTE_PRICES_REQUEST' as const;
export const postChangeQuotePricesSuccessAction =
    'contract/POST_CHANGE_QUOTE_PRICES_SUCCESS' as const;
export const postChangeQuotePricesFailureAction =
    'contract/POST_CHANGE_QUOTE_PRICES_FAILURE' as const;
export const postPaymentScheduleRequestAction = 'contract/POST_PAYMENT_SCHEDULE_REQUEST' as const;
export const postPaymentScheduleSuccessAction = 'contract/POST_PAYMENT_SCHEDULE_SUCCESS' as const;
export const postPaymentScheduleFailureAction = 'contract/POST_PAYMENT_SCHEDULE_FAILURE' as const;
export const changeCurrencyPaymentScheduleAction =
    'contract/CHANGE_CURRENCY_PAYMENT_SCHEDULE' as const;
export const putPaymentScheduleRequestAction = 'contract/PUT_PAYMENT_SCHEDULE_REQUEST' as const;
export const putPaymentScheduleSuccessAction = 'contract/PUT_PAYMENT_SCHEDULE_SUCCESS' as const;
export const putPaymentScheduleFailureAction = 'contract/PUT_PAYMENT_SCHEDULE_FAILURE' as const;
export const postInstalmentRequestAction = 'contract/POST_INSTALMENT_REQUEST' as const;
export const postInstalmentSuccessAction = 'contract/POST_INSTALMENT_SUCCESS' as const;
export const postInstalmentFailureAction = 'contract/POST_INSTALMENT_FAILURE' as const;
export const putInstalmentRequestAction = 'contract/PUT_INSTALMENT_REQUEST' as const;
export const putInstalmentSuccessAction = 'contract/PUT_INSTALMENT_SUCCESS' as const;
export const putInstalmentFailureAction = 'contract/PUT_INSTALMENT_FAILURE' as const;
export const deleteInstalmentRequestAction = 'contract/DELETE_INSTALMENT_REQUEST' as const;
export const deleteInstalmentSuccessAction = 'contract/DELETE_INSTALMENT_SUCCESS' as const;
export const deleteInstalmentFailureAction = 'contract/DELETE_INSTALMENT_FAILURE' as const;

export const fetchContract = (contractId: ContractId): FetchContractRequestAction => ({
    type: fetchContractRequestAction,
    contractId,
});

export const getContractSuccess = (
    response: Contract | null,
    contractId: ContractId,
): FetchContractSuccessAction => ({
    type: fetchContractSuccessAction,
    contractId,
    response,
});

export const getContractFailure = (
    error: string,
    contractId: ContractId,
): FetchContractFailureAction => ({
    type: fetchContractFailureAction,
    contractId,
    error,
});

export const postContract = (
    contractId: ContractId,
    travelInformation: TravelInformation,
    travelers: Traveler[],
): PostContractRequestAction => ({
    type: postContractRequestAction,
    contractId,
    travelInformation,
    travelers,
});

export const postContractSuccess = (
    response: Contract,
    contractId: ContractId,
): PostContractSuccessAction => ({
    type: postContractSuccessAction,
    response,
    contractId,
});

export const postContractFailure = (
    error: string,
    contractId: ContractId,
): PostContractFailureAction => ({
    type: postContractFailureAction,
    contractId,
    error,
});

export const fetchLegalInformation = (
    contractId: ContractId,
): FetchLegalInformationRequestAction => ({
    type: fetchLegalInformationRequestAction,
    contractId,
});

export const getLegalInformationSuccess = (
    response: SerializedLegalInformation[],
    contractId: ContractId,
): FetchLegalInformationSuccessAction => ({
    type: fetchLegalInformationSuccessAction,
    contractId,
    response,
});

export const getLegalInformationFailure = (
    error: string,
    contractId: ContractId,
): FetchLegalInformationFailureAction => ({
    type: fetchLegalInformationFailureAction,
    contractId,
    error,
});

export const setContractEditStep = (step: ContractEditStep): SetContractEditStepAction => ({
    type: setContractEditStepAction,
    step,
});

export const fetchQuotePricing = (contractId: ContractId): FetchQuotePricingRequestAction => ({
    type: fetchQuotePricingRequestAction,
    contractId,
});

export const getQuotePricingSuccess = (
    response: QuotePricing | null,
    contractId: ContractId,
): FetchQuotePricingSuccessAction => ({
    type: fetchQuotePricingSuccessAction,
    contractId,
    response,
});

export const getQuotePricingFailure = (
    error: string,
    contractId: ContractId,
): FetchQuotePricingFailureAction => ({
    type: fetchQuotePricingFailureAction,
    contractId,
    error,
});

export const postProofOfDocumentsRequest = (
    contractId: ContractId,
    file: File,
): PostProofOfDocumentsRequestAction => ({
    type: postProofOfDocumentsRequestAction,
    contractId,
    file,
});

export const postProofOfDocumentsSuccess = (
    response: ProofDocument,
    fileName: string,
): PostProofOfDocumentsSuccessAction => ({
    type: postProofOfDocumentsSuccessAction,
    response,
    fileName,
});

export const postProofOfDocumentsFailure = (
    error: string,
    file: File,
): PostProofOfDocumentsFailureAction => ({
    type: postProofOfDocumentsFailureAction,
    error,
    file,
});

export const deleteProofOfDocumentsRequest = (
    fileName: string,
): DeleteProofOfDocumentsRequestAction => ({
    type: deleteProofOfDocumentRequestAction,
    fileName,
});

export const deleteProofOfDocumentsSuccess = (
    response: ProofDocument,
    fileName: string,
): DeleteProofOfDocumentsSuccessAction => ({
    type: deleteProofOfDocumentsSuccessAction,
    response,
    fileName,
});

export const deleteProofOfDocumentsFailure = (
    error: string,
): DeleteProofOfDocumentsFailureAction => ({
    type: deleteProofOfDocumentsFailureAction,
    error,
});

export const postChangeQuotePricesRequest = (
    contractId: ContractId,
    quotePrices: FilledQuotePricing,
): PostChangeQuotePricesRequestAction => ({
    type: postChangeQuotePricesRequestAction,
    contractId,
    quotePrices,
});

export const postChangeQuotePricesSuccess = (
    response: QuotePricing,
): PostChangeQuotePricesSuccessAction => ({
    type: postChangeQuotePricesSuccessAction,
    response,
});

export const postChangeQuotePricesFailure = (
    error: string,
): PostChangeQuotePricesFailureAction => ({
    type: postChangeQuotePricesFailureAction,
    error,
});

export const goToPreviousStep = (): PreviousContractEditStepAction => ({
    type: goToPreviousContractEditStepAction,
});

export const postPaymentScheduleRequest = (
    contractId: ContractId,
    paymentSchedule: PaymentScheduleViewModel,
    onSuccess?: () => void,
): PostPaymentScheduleRequestAction => ({
    type: postPaymentScheduleRequestAction,
    contractId,
    paymentSchedule,
    onSuccess,
});

export const postPaymentScheduleSuccess = (
    response: ExistingPaymentSchedule,
): PostPaymentScheduleSuccessAction => ({
    type: postPaymentScheduleSuccessAction,
    response,
});

export const postPaymentScheduleFailure = (error: string): PostPaymentScheduleFailureAction => ({
    type: postPaymentScheduleFailureAction,
    error,
});

export const changeCurrencyPaymentSchedule = (
    paymentSchedule: PaymentScheduleViewModel,
    currency: string,
): ChangeCurrencyPaymentScheduleAction => ({
    type: changeCurrencyPaymentScheduleAction,
    paymentSchedule,
    currency,
});

export const putPaymentScheduleRequest = (
    contractId: ContractId,
    paymentSchedule: PaymentScheduleViewModel,
    onSuccess?: () => void,
): PutPaymentScheduleRequestAction => ({
    type: putPaymentScheduleRequestAction,
    contractId,
    paymentSchedule,
    onSuccess,
});

export const putPaymentScheduleSuccess = (
    response: ExistingPaymentSchedule,
): PutPaymentScheduleSuccessAction => ({
    type: putPaymentScheduleSuccessAction,
    response,
});

export const putPaymentScheduleFailure = (error: string): PutPaymentScheduleFailureAction => ({
    type: putPaymentScheduleFailureAction,
    error,
});

export const postInstalmentRequest = (
    contractId: ContractId,
    instalment: InstalmentViewModel,
): PostInstalmentRequestAction => ({
    type: postInstalmentRequestAction,
    contractId,
    instalment,
});

export const postInstalmentSuccess = (
    response: ExistingPaymentSchedule,
): PostInstalmentSuccessAction => ({
    type: postInstalmentSuccessAction,
    response,
});

export const postInstalmentFailure = (error: string): PostInstalmentFailureAction => ({
    type: postInstalmentFailureAction,
    error,
});

export const putInstalmentRequest = (
    contractId: ContractId,
    instalment: InstalmentViewModel,
): PutInstalmentRequestAction => ({
    type: putInstalmentRequestAction,
    contractId,
    instalment,
});

export const putInstalmentSuccess = (
    response: ExistingPaymentSchedule,
): PutInstalmentSuccessAction => ({
    type: putInstalmentSuccessAction,
    response,
});

export const putInstalmentFailure = (error: string): PutInstalmentFailureAction => ({
    type: putInstalmentFailureAction,
    error,
});

export const deleteInstalmentRequest = (
    contractId: ContractId,
    instalmentId: string,
): DeleteInstalmentRequestAction => ({
    type: deleteInstalmentRequestAction,
    contractId,
    instalmentId,
});

export const deleteInstalmentSuccess = (
    response: ExistingPaymentSchedule,
): DeleteInstalmentSuccessAction => ({
    type: deleteInstalmentSuccessAction,
    response,
});

export const deleteInstalmentFailure = (error: string): DeleteInstalmentFailureAction => ({
    type: deleteInstalmentFailureAction,
    error,
});
